import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { StudyFilterRequest, StudyResponse } from 'types/studies';
import { getStudies, getStudyFilterOptions } from '../services/studies';

interface StudiesResponse {
    totalCount: number;
    data: StudyResponse[];
}

export const studyApi = createApi({
    reducerPath: 'studyApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/' }),
    endpoints: (builder) => ({
        getStudies: builder.query<StudiesResponse, StudyFilterRequest>({
            queryFn: async (filters) => {
                try {
                    const data = await getStudies(filters);
                    return { data };
                } catch (error) {
                    return { error: error.message || 'Failed to fetch studies' };
                }
            },
        }),
        getStudyFilterOptions: builder.query<any, void>({
            queryFn: async () => {
                try {
                    const options = await getStudyFilterOptions();
                    const result = {
                        ...options,
                        submittedByNames: options.submittedByNames.map((elem: any) => ({
                            id: elem,
                            description: elem === null ? '-' : elem,
                        })),
                    };
                    return { data: result };
                } catch (error) {
                    return { error: error.message || 'Failed to fetch study filter options' };
                }
            },
        }),
    }),
});

export const useGetStudies = studyApi.endpoints.getStudies.useQuery;
export const useGetStudyFilterOptions = studyApi.endpoints.getStudyFilterOptions.useQuery;
